module.exports = __webpack_public_path__ + "static/media/promoIcon.pictogram.6bb2b934.svg";